import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import { ErrorMarkIcon } from '@components/icons/error-mark-icon';

import { LandscapeErrorContainer } from './styles';

export const LandscapeError: React.FC = () => {
    const { t } = useTranslation();

    return (
        <LandscapeErrorContainer className='access-container'>
            <ErrorMarkIcon className='access-container-icon' />
            <Typography tag='h4' variant='h2' color='text-main' className='access-container-title'>
                {t('docVerificationWidget.landscapeError.title')}
            </Typography>
            <Typography tag='p' variant='text' color='text-light' className='access-container-text'>
                {t('docVerificationWidget.landscapeError.description')}
            </Typography>
        </LandscapeErrorContainer>
    );
};
